var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldSearchUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_search-user_00000011746231254621062570000003845727782233412278_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,0L24,0v24H0V0H24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_search-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-user"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M2,11c0,5,4,9,9,9s9-4,9-9s-4-9-9-9S2,6,2,11z M13.1,8.2c0,1.2-0.9,2.1-2.1,2.1h0h0c0,0,0,0-0.1,0 c-1.2,0-2.1-1-2.1-2.1C8.8,7,9.8,6,10.9,6C12.1,6,13.1,7,13.1,8.2z M11,16c-0.8,0-1.6-0.2-2.2-0.6c-0.6-0.4-0.9-0.9-0.9-1.5 c0-0.6,0.3-1.1,0.9-1.5c1.2-0.8,3.2-0.8,4.4,0c0.6,0.4,0.9,0.9,0.9,1.5c0,0.6-0.3,1.1-0.9,1.5C12.6,15.8,11.8,16,11,16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000077312357613365342820000007118456580905624225_",
    fill: "{props.color}",
    d: "M20,18c-0.7,0-1.3,0.3-1.7,0.8 s-0.4,1.2-0.2,1.8c0.4,1.3,1.2,1.6,1.6,1.6c0.1,0,0.1,0,0.2,0c0.4,0,1.1-0.2,1.8-1.2c0.5-0.8,0.6-1.5,0.3-2.1 C21.7,18.3,21,18,20,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000125588656519855687120000010956038021273410440_",
    fill: "none",
    d: "M0,24V0h24v24H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSearchUser);
export default __webpack_public_path__ + "static/media/vuesax-bold-search-user.810ca7cff6fb4aa4099e09c530b04602.svg";
export { ForwardRef as ReactComponent };